export default __webpack_public_path__ + "static/media/zh-medical-card.2df6ccd8.png";